import React, { useState } from 'react';
import { useAuth } from '../firebase/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [isWithdrawing, setIsWithdrawing] = useState(false);
  const { userProfile, sessionId, logout } = useAuth();
  const navigate = useNavigate();

  const openModal = async (url) => {
    try {
      const response = await fetch(url);
      const htmlContent = await response.text();
      setModalContent(htmlContent);
      setShowModal(true);
    } catch (error) {
      console.error('Failed to load content:', error);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent('');
  };

  const handleContact = () => {
    // お問い合わせの処理（メールリンクなど）
    window.open('mailto:support@tinyidentity.com');
  };

    const handleWithdraw = async () => {
    setIsWithdrawing(true);
    try {
      const { withdrawUser } = await import('../firebase/api');
      const result = await withdrawUser(sessionId);
      
      if (result.success) {
        alert('退会処理が完了しました。ご利用ありがとうございました。');
        
        // 完全なログアウト処理（AuthContextのlogout関数を使用）
        await logout();
        
        // Firebase認証からもサインアウト
        const { signOut } = await import('firebase/auth');
        const { auth } = await import('../firebase/config');
        await signOut(auth);
        
        // スタート画面に戻る
        navigate('/');
      } else {
        alert(`退会処理に失敗しました: ${result.message}`);
      }
    } catch (error) {
      console.error('Withdraw error:', error);
      alert('退会処理中にエラーが発生しました。');
    } finally {
      setIsWithdrawing(false);
      setShowWithdrawModal(false);
    }
  };

  const openWithdrawModal = () => {
    setShowWithdrawModal(true);
  };

  const closeWithdrawModal = () => {
    setShowWithdrawModal(false);
  };

  return (
    <>
      <footer className="app-footer">
        <div className="footer-content">
          <a 
            href="#" 
            onClick={(e) => { e.preventDefault(); openModal('/terms.html'); }}
            className="footer-link"
          >
            利用規約
          </a>
          <span className="footer-separator">|</span>
          <a 
            href="#" 
            onClick={(e) => { e.preventDefault(); openModal('/privacy.html'); }}
            className="footer-link"
          >
            プライバシーポリシー
          </a>
          <span className="footer-separator">|</span>
          <a 
            href="#" 
            onClick={(e) => { e.preventDefault(); openModal('/tokutei.html'); }}
            className="footer-link"
          >
            特定商取引法に基づく表記
          </a>
          <span className="footer-separator">|</span>
          <a 
            href="#" 
            onClick={(e) => { e.preventDefault(); handleContact(); }}
            className="footer-link"
          >
            お問い合わせ
          </a>
          {userProfile && sessionId && (
            <>
              <span className="footer-separator">|</span>
              <a 
                href="#" 
                onClick={(e) => { e.preventDefault(); openWithdrawModal(); }}
                className="footer-link footer-withdraw"
              >
                退会
              </a>
            </>
          )}
        </div>
      </footer>

      {/* 文書モーダル */}
      {showModal && (
        <div className="footer-modal-overlay">
          <div className="footer-modal-content">
            <div className="footer-modal-header">
              <h3>文書</h3>
              <button
                onClick={closeModal}
                className="footer-modal-close"
              >
                ×
              </button>
            </div>
            <div 
              className="footer-modal-body"
              dangerouslySetInnerHTML={{ __html: modalContent }}
            />
          </div>
        </div>
      )}

      {/* 退会確認モーダル */}
      {showWithdrawModal && (
        <div className="footer-modal-overlay">
          <div className="footer-modal-content-withdraw footer-withdraw-modal">
            <div className="footer-modal-body">
              <p>本当に退会しますか？</p>
              <p className="withdraw-warning">
                ※ 退会すると、作成したポスターやお気に入りなどのデータにアクセスできなくなります。
              </p>
              <div className="withdraw-buttons">
                <button
                  onClick={closeWithdrawModal}
                  className="btn-primary"
                  disabled={isWithdrawing}
                >
                  キャンセル
                </button>
                <button
                  onClick={handleWithdraw}
                  className="btn-primary btn-withdraw"
                  disabled={isWithdrawing}
                >
                  {isWithdrawing ? '処理中...' : '退会する'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
